import { useFormContext } from 'react-hook-form';

import { ReferenceField, SolutionField } from '../../components';
import { CognitiveDomainField } from '../cognitive-domain-field';
import { LearningObjectiveStatementField } from '../learning-objective-statement-field';
import type { LocationSectionType } from '../location-section';
import type { PropertiesSectionType } from '../properties-section';

interface PropertiesFormSectionProps {
  questionId?: string;
}

export default function PropertiesFormSection(props: Readonly<PropertiesFormSectionProps>) {
  const { questionId } = props;

  const { watch } = useFormContext<PropertiesSectionType & LocationSectionType>();
  const cognitive = watch('properties.cognitiveDomain') ?? [];
  const chapterLevelItemId = watch('location.CHAPTER.value') ?? null;

  return (
    <>
      <CognitiveDomainField
        name='properties.cognitiveDomain'
        placeholder={
          cognitive.length !== 0 ? undefined : 'กรุณาเลือกคุณลักษณะของข้อสอบ (Cognitive Domain)'
        }
      />
      <LearningObjectiveStatementField
        name='properties.learningObjectiveStatement'
        chapterLevelItemId={chapterLevelItemId}
        required
      />
      <SolutionField name='properties.solution' questionId={questionId} required />
      <ReferenceField name='properties.reference' questionId={questionId} required />
    </>
  );
}
